/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
import { Api } from '@/services/Api'

const deviceList = (param) => {
  return Api().post('/api/v1.0/analytics/device-list', param)
}
const parametersList = (param) => {
  return Api().get(`/api/v2/parameter/${param}`)
}
const aggregateParametersList = (param) => {
  return Api().get(`/api/v2/parameter/aggregate/${param}`)
}
const getGraphData = (param) => {
  return Api().post('/api/v2/analytics/graph', param)
}

const getTableData = (param) => {
  return Api().post('/api/v2/analytics/table', param)
}

const downloadTableData = (param) => {
  return Api().post('/api/v2/analytics/table/download', param)
}

const setTemplate = (param) => {
  return Api().post('/api/v1.0/analytics/template', param)
}

const getTemplate = (plantId) => {
  return Api().get(`/api/v1.0/analytics/template/${plantId}`)
}

export {
  deviceList,
  parametersList,
  getGraphData,
  getTableData,
  downloadTableData,
  setTemplate,
  getTemplate,
  aggregateParametersList
}
